import styled, { css } from 'styled-components'

export const PropertyTagsContainer = styled.div`
  position: relative;
`

export const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  cursor: pointer;
  padding: 4px;
  margin: -4px;
  border-radius: 8px;
  transition: all 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.02);
  }
`

export const EmptyStateContainer = styled.div`
  display: inline-block;
`

export const PropertyTag = styled.span<{
  $color: string
  $isPrimary?: boolean
}>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  transition: all 0.2s;
  position: relative;

  ${({ $isPrimary }) =>
    $isPrimary &&
    css`
      padding-right: 8px;
      font-weight: 600;
    `}

  color: ${({ $color }) =>
    $color && $color.trim() !== '' ? $color : '#374151'};

  background: ${({ $color, $isPrimary }) => {
    if (!$color || $color.trim() === '') return '#e5e7eb'

    // Convert hex to RGB for gradient
    const hex = $color.replace('#', '')
    const r = parseInt(hex.substr(0, 2), 16)
    const g = parseInt(hex.substr(2, 2), 16)
    const b = parseInt(hex.substr(4, 2), 16)

    // Slightly more opaque for primary tags
    const opacity1 = $isPrimary ? 0.15 : 0.1
    const opacity2 = $isPrimary ? 0.25 : 0.2

    return `linear-gradient(135deg, rgba(${r}, ${g}, ${b}, ${opacity1}) 0%, rgba(${r}, ${g}, ${b}, ${opacity2}) 100%)`
  }};

  ${({ $isPrimary, $color }) =>
    $isPrimary &&
    css`
      border: 1px solid
        ${(() => {
          if (!$color || $color.trim() === '') return '#d1d5db'
          const hex = $color.replace('#', '')
          const r = parseInt(hex.substr(0, 2), 16)
          const g = parseInt(hex.substr(2, 2), 16)
          const b = parseInt(hex.substr(4, 2), 16)
          return `rgba(${r}, ${g}, ${b}, 0.3)`
        })()};
    `}

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    background: ${({ $color, $isPrimary }) => {
      if (!$color || $color.trim() === '') return '#d1d5db'

      const hex = $color.replace('#', '')
      const r = parseInt(hex.substr(0, 2), 16)
      const g = parseInt(hex.substr(2, 2), 16)
      const b = parseInt(hex.substr(4, 2), 16)

      const opacity1 = $isPrimary ? 0.2 : 0.15
      const opacity2 = $isPrimary ? 0.3 : 0.25

      return `linear-gradient(135deg, rgba(${r}, ${g}, ${b}, ${opacity1}) 0%, rgba(${r}, ${g}, ${b}, ${opacity2}) 100%)`
    }};
  }
`

export const PrimaryIndicator = styled.span`
  font-size: 10px;
  color: inherit;
  opacity: 0.8;
  margin-left: 2px;
`

export const AddTagButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 10px;
  background: transparent;
  border: 1px dashed #9ca3af;
  border-radius: 6px;
  color: #6b7280;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;

  &:hover {
    border-color: #60a5fa;
    color: #3b82f6;
    background: rgba(96, 165, 250, 0.05);
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(96, 165, 250, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
`

export const PlusIcon = styled.svg`
  width: 12px;
  height: 12px;
  stroke-width: 2;
`
